import React from 'react';
import { Button } from 'antd';
import './AdminEditProduct.css';

const AdminEditProduct = () => {
  return (
    <div className="admin-edit-product-container">
      <form className="admin-edit-product-form">
        <input
          type="text"
          placeholder="Nome do Produto"
          className="admin-edit-product-input"
        />
        <textarea
          placeholder="Descrição do Produto"
          className="admin-edit-product-textarea"
        />
        <input
          type="number"
          placeholder="Preço"
          className="admin-edit-product-input"
        />
        <Button type="primary" className="admin-edit-product-button">
          Salvar Alterações
        </Button>
      </form>
    </div>
  );
};

export default AdminEditProduct;
